import styled from 'styled-components';
import { TabContentWrapper } from '../UI/styledConstants';


export const Wrapper = styled(TabContentWrapper)`
 &.bbps{
	background-color: transparent;
	box-shadow: none;
   }
.headingText{
	margin-bottom: 20px!important;
}
	.payee-actions {
		button {
			min-width: 80px;
		}
	}
`;


export const ServiceBoxWrapper = styled.div`
   width: 100%;
   /* background-color: #fff; */
   min-height: 400px;
&.bbps{
	margin-bottom: 50px;
}
   .header{
	margin-bottom: 36px;
	margin-top: 20px;
	gap: 10px;

	
	
	h2{
		margin: 0;
		font-size: 40px;
		font-family: "Poppins", serif;
		color: #fff;
		text-align: center;
	}
	.logo{
		flex: 0 0 90px;
	   background-color: #fff;
	   padding: 10px;
	   border-radius: 10px;
	}
	img{
		width: 100%;
	}
	
   }
   .service-box-body{
	padding: 0px 35px 50px 35px;
	background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 1px 0px 50px #0000001C;
border-radius: 20px;
&>h2{
	text-align: center;
	padding-block: 42px;
	font-size: 20px;
	font-family: "Poppins", serif;
}
   }
   .service-box{
	
	gap: 10px;
	flex-wrap: wrap;
	
	
   }
   .serviceCard{
	width: calc(16.5% - 8px);
	height: 100px;

	background: #F4F8FB 0% 0% no-repeat padding-box;
    border-radius: 10px;
	cursor: pointer;
	transition: all .3s ease-in-out;
	text-align: center;

	h3{
   color: #333;
   transition: all .3s;
margin-top: 10px;
font-family: Poppins;
font-weight: 500;
font-size: 12px;
	}
	img{
		height: 30px;
		width: auto;
	
	}
	&:hover{
		box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
		h3{
			color: var(--header-color_hover)

	}
	
	}

	
   }
   .mainService{
	
	.serviceCard{
		
		img{
			min-height: 40px;
		}
		svg{
			.path-stroke,#Ellipse_42,#Path_197,#Line_6,#Subtraction_4,#Path_550{
    stroke: rgb(0, 41, 112);
}
		}
		#Line_5{
			fill: rgb(0, 41, 112);
		}
		.path-stroke-white{
			stroke:#fff;
		}
		#Aadhaar_pay-blue-without_name path,.path-color{
			fill: rgb(0, 41, 112)
		}
	 }

	 
   }
   @media only screen and (max-width: 992px) {
	.serviceCard{
		width: calc(25% - 20px);
	}
   }
   @media only screen and (max-width: 767px) {
	.serviceCard{
		width: calc(33.33% - 14px);
	}
	.header{
		h2{
			font-size: 24px;
			
		}
	}
	.service-box-body{
          &>h2 {
		margin-bottom: 0;
    
		
    
		  }
	}
	.personal-information{
		padding: 30px 0px;
	}
   }
   @media only screen and (max-width: 480px) {
	.serviceCard{
		width: calc(50% - 10px);
	}
	.header{
		h2{
			font-size: 20px;
			display: none;
		}
	}
	.service-box-body{
          &>h2 {
			font-size: 14px;
        line-height: 16px;
        padding-block: 22px;

    
		  }
	}
	.service-box-body {
		padding: 0px 20px 30px 20px;
   }
}
   @media only screen and (max-width: 380px) {
	.serviceCard{
		width: 100%;
	}
   }

`;